// eslint-disable-next-line no-restricted-imports
import { Pressable } from 'dripsy';

export default Pressable;
